import { LegalPageLayout } from './LegalPageLayout';

export function NoteLegaliPage() {
  return (
    <LegalPageLayout title="Note Legali e Informazioni Societarie">
      <p className="mt-2 text-sm text-neutral-500">Ultima revisione: 7 Maggio 2026</p>
                  
                    <h2>1. Informazioni Societarie Obbligatorie</h2>
                    <p>
                      Ai sensi dell&apos;Art. 2250 del Codice Civile e del D.Lgs. 70/2003, si forniscono i dati
                      ufficiali del Titolare:
                    </p>
                    <ul>
                      <li>
                        <strong>Denominazione Sociale:</strong> Klaro7 S.r.l.s.
                      </li>
                      <li>
                        <strong>Sede Legale:</strong> Via Prospero, 5/b – 10095 Grugliasco (TO)
                      </li>
                      <li>
                        <strong>Partita IVA / Codice Fiscale:</strong> 13344040012
                      </li>
                      <li>
                        <strong>REA:</strong> TO - 1356566
                      </li>
                      <li>
                        <strong>Capitale Sociale:</strong> € 1.000,00 i.v.
                      </li>
                      <li>
                        <strong>PEC:</strong> <a href="mailto:klaro7@pec.it">klaro7@pec.it</a>
                      </li>
                      <li>
                        <strong>E-mail Assistenza:</strong>{' '}
                        <a href="mailto:assistenza@klaro7.com">assistenza@klaro7.com</a>
                      </li>
                    </ul>
      
                    <h2>2. Disclaimer e Natura dei Servizi (Clausola di Limitazione)</h2>
                    <p>
                      <strong>Natura del Servizio:</strong> La Piattaforma Klaro7 eroga servizi basati su
                      discipline esoteriche, spirituali e arti divinatorie. L&apos;Utilizzatore riconosce che
                      tali servizi hanno esclusivamente finalità di intrattenimento, ludiche e di supporto
                      motivazionale. <strong>Esclusione di Responsabilità Professionale:</strong> In nessun caso
                      i consulti devono essere interpretati come consulenze mediche, legali, finanziarie o
                      psicologiche. Klaro7 S.r.l.s. non garantisce la veridicità o l&apos;accuratezza delle
                      previsioni fornite, in quanto prive di fondamento scientifico.{' '}
                      <strong>Intermediazione Tecnica:</strong> Klaro7 agisce come mero intermediario tecnico
                      (Hosting Provider). La Società non risponde dei contenuti, delle opinioni o della condotta
                      degli Operatori, né di eventuali danni derivanti dall&apos;affidamento che l&apos;Utente
                      ripone nelle informazioni ottenute.
                    </p>
      
                    <h2>3. Proprietà Intellettuale e Tutela del Brand</h2>
                    <p>
                      <strong>Titolarità:</strong> Il nome &quot;Klaro7&quot;, il logo, il design del sito, i
                      testi (comprese le FAQ e i contratti), i software, i database e ogni altro contenuto sono
                      di proprietà esclusiva di Klaro7 S.r.l.s. o dei suoi licenziatari.{' '}
                      <strong>Divieto di Copia:</strong> È severamente vietata la riproduzione, anche parziale,
                      la copia, la distribuzione o l&apos;utilizzo non autorizzato di qualsiasi elemento presente
                      sulla Piattaforma. Ogni violazione sarà perseguita civilmente e penalmente ai sensi delle
                      leggi sul Diritto d&apos;Autore (L. 633/1941). <strong>Web Scraping:</strong> È fatto
                      divieto di utilizzare sistemi automatici (bot, crawler, spider) per estrarre dati dalla
                      Piattaforma senza autorizzazione scritta.
                    </p>
      
                    <h2>4. Immagini e Contenuti Generati con Intelligenza Artificiale</h2>
                    <p>
                      Alcune immagini presenti sulla Piattaforma (illustrazioni, sfondi, elementi
                      grafici e decorativi delle pagine informative e promozionali) sono{' '}
                      <strong>generate o elaborate con strumenti di intelligenza artificiale</strong> e
                      hanno finalità puramente illustrativa. Tali immagini non raffigurano persone
                      reali, non costituiscono documentazione di fatti o eventi realmente accaduti e non
                      rappresentano gli Operatori iscritti alla Piattaforma. Le fotografie dei profili
                      degli Operatori sono invece caricate direttamente dagli stessi, che ne
                      garantiscono la titolarità e la veridicità. Eventuali contenuti sintetici sono
                      identificati come tali in conformità agli obblighi di trasparenza previsti
                      dall&apos;art. 50 del Regolamento (UE) 2024/1689 (AI Act).
                    </p>

                    <h2>5. Clausola di Manleva</h2>
                    <p>
                      L&apos;Utilizzatore si impegna a tenere indenne e manlevata Klaro7 S.r.l.s. da qualsiasi
                      pretesa, danno, perdita o spesa (incluse le spese legali) derivante da:
                    </p>
                    <ol>
                      <li>Uso improprio della Piattaforma.</li>
                      <li>
                        Violazione delle presenti Note Legali o delle Condizioni Generali d&apos;Uso (CGU).
                      </li>
                      <li>Decisioni personali prese a seguito dei consulti erogati dagli Operatori.</li>
                    </ol>
      
                    <h2>6. Link Esterni e Siti Terzi</h2>
                    <p>
                      Klaro7 non esercita alcun controllo sui contenuti di eventuali siti terzi raggiungibili
                      tramite link presenti sulla Piattaforma e declina ogni responsabilità per danni o perdite
                      derivanti dal loro utilizzo.
                    </p>
      
                    <h2>7. Legge Applicabile e Giurisdizione</h2>
                    <p>
                      Le presenti Note Legali sono regolate dalla Legge Italiana. Ogni controversia relativa alla
                      validità, interpretazione o esecuzione delle stesse sarà devoluta alla competenza esclusiva
                      del Foro di Torino, fatti salvi i diritti spettanti all&apos;Utente Consumatore ai sensi del
                      Codice del Consumo.
                    </p>
    </LegalPageLayout>
  );
}
